import CarEntity, { TransmissionCar } from "../../../domain/entities/CarEntity";
import { imageKey, ImageVariant } from "../../../utils/image";
import BrandImplDto from "./BrandImplDto";
import ModelImplDto from "./ModelImplDto";
import ColorImplDto from "./ColorImplDto";
import PriceBookImplDto from "./PriceBookImplDto";
import TagImplDto from "./TagImplDto";
import TypeOfFueImpllDto from "./TypeOfFueImpllDto";
import TypeVehicleImplDto from "./TypeVehicleImplDto";

const fromJson = (json: any): CarEntity => {
    let imagesCar = json?.files ? json?.files?.map((file: any) => file.image) : [];
    imagesCar?.unshift(json?.image_first);

    // Variantes de resolucion (srcset) que sirve el backend. Se indexan por nombre de
    // archivo normalizado para poder asociarlas luego con cada URL de imagen, robusto al
    // dedup/reordenamiento de los carousels. Mientras el backfill del backend no corra,
    // estos arreglos llegan vacios y el front cae al comportamiento actual (src normal).
    const photoUrlSrcset: ImageVariant[] = Array.isArray(json?.image_first_srcset) ? json.image_first_srcset : [];
    const imageSrcsetByKey: Record<string, ImageVariant[]> = {};
    if (json?.image_first && photoUrlSrcset.length) {
        imageSrcsetByKey[imageKey(json.image_first)] = photoUrlSrcset;
    }
    if (Array.isArray(json?.files)) {
        json.files.forEach((file: any) => {
            if (file?.image && Array.isArray(file?.image_srcset) && file.image_srcset.length) {
                imageSrcsetByKey[imageKey(file.image)] = file.image_srcset;
            }
        });
    }

    return {
        id: json.id,
        name: json.car,
        model: typeof json.version === "object" && json.version ? json.version.version : json.version,
        type: TypeVehicleImplDto.fromJson(json.type),
        photoUrl: json.image_first,
        images: imagesCar,
        previewImages: Array.isArray(json.preview_images) ? json.preview_images.filter(Boolean) : [],
        photoUrlSrcset,
        imageSrcsetByKey,
        price: parseInt(json.price),
        transmission: json.transmission == 1 ? TransmissionCar.AUTOMATIC : TransmissionCar.MANUAL,
        year: json.year,
        rating: parseFloat(json.stars),
        odometer: json.mileage,
        brand: BrandImplDto.fromJson(json.brand_car),
        typeOfFuel: TypeOfFueImpllDto.fromJson(json.fuel_type),
        color: ColorImplDto.fromJson(json.color_car),
        priceBook: json.billing_car ? PriceBookImplDto.fromJson(json.billing_car) : undefined,
        garantia7dias: json.garantie7Day,
        description: json.description,
        tag: json.tag_car ? TagImplDto.fromJson(json.tag_car) : undefined,
        plate: json.tuition,
        fullPlate: json.tuition,
        doors: json.doors,
        motor: json.engine,
        status: json.status_vehicle == 1 ? "Nuevo" : "Usado",
        discount_price:
            json.discount_price != null && json.discount_price != "0.00" ? parseFloat(json.discount_price) : undefined,
        url_expertise: json.url_expertise,
        expertise: json.expertise,
        id_colserauto: json.id_colserauto,
        claims: json.claims,
        amount_claims: json.amount_claims,
        warranty: json.warranty,
        type_warranty: json.type_warranty,
        types_claims: json.types_claims,
        traction: json.traction,
        quantityPersons: json.quantityPersons <= 9 ? json.quantityPersons + 9 : json.quantityPersons,
        warranty_type: json.warranty_type,
        description_ai: json.description_ai,
        type_negotiation: json.type_negotiation,
        automas: json.automas,
        automas_pdf: json.automas_pdf ?? null,
        active: json.active,
        image_complaint: json.image_complaint,
        sede: json.sede ?? null,
        sede_car: json.sede_car,
        factory_warranty_coverage: json.factory_warranty_coverage ?? null,
        warranty_plan_car: json.warranty_plan_car ?? null,
        videoUrl: json.video_url ?? null,
    };
};

const toJson = (car: CarEntity): any => {
    return {
        id: car.id,
        name: car.name,
        model: car.model,
        type: TypeVehicleImplDto.toJson(car.type),
        image_first: car.photoUrl,
        images: car.images,
        price: car.price,
        transmission: car.transmission == TransmissionCar.AUTOMATIC,
        year: car.year,
        rating: car.rating,
        odometer: car.odometer,
        brand: BrandImplDto.toJson(car.brand),
        typeOfFuel: TypeOfFueImpllDto.toJson(car.typeOfFuel),
        color_car: ColorImplDto.toJson(car.color),
        priceBook: car.priceBook ? PriceBookImplDto.toJson(car.priceBook) : undefined,
        description: car.description,
        tag: car.tag ? TagImplDto.toJson(car.tag) : undefined,
        plate: car.plate,
        doors: car.doors,
        motor: car.motor,
        status: car.status == "Nuevo" ? 1 : 2,
        claims: car.claims,
        amount_claims: car.amount_claims,
        warranty: car.warranty,
        type_warranty: car.type_warranty,
        types_claims: car.types_claims,
        traction: car.traction,
        description_ai: car.description_ai,
        warranty_type: car.warranty_type,
        automas: car.automas,
        automas_pdf: car.automas_pdf,
        active: car.active,
        type_negotiation: car.type_negotiation,
        image_complaint: car.image_complaint,
        sede_car: car.sede_car,
    };
};

export default {
    fromJson,
    toJson,
};
